<template>
  <el-drawer
    :visible.sync="modelValue"
    :direction="direction"
    title="我的内容"
    custom-class="photo-model-dialog"
    :modal="false"
    :size="size"
    :with-header="false"
  >
    <div class="header font-body">
      <div class="header-title">
        <i class="iconfont icontuichu" @click="handelClose"></i>
        <div class="header-title-name">{{ relicName }}</div>
      </div>
      <ul class="header-list">
        <li
          v-show="item.visible"
          @click="isActive = index + 1"
          class="header-List-item"
          v-for="(item, index) in navList"
          :key="index"
          :class="{ 'is-active': isActive === index + 1 }"
        >
          {{ item.label }}
        </li>
      </ul>
    </div>
    <div class="tab">
      <phone-model-dialog-info-vue
        v-show="isActive === 1"
        :relicInfo="relicInfo"
        :photos="photos"
      />
      <model-point-cloud-vue :relicInfo="relicInfo" v-show="isActive === 2" />
      <phone-model-swiper-vue
        v-show="isActive === 3"
        :photos="drawings"
        :visibleSize="visibleSize"
      />
      <phone-model-swiper-vue
        v-show="isActive === 4"
        :photos="photos"
        :visibleSize="visibleSize"
      />
    </div>
  </el-drawer>
</template>

<script>
import { mixinModel } from '../assets/js/model';
import modelPointCloudVue from './model-point-cloud.vue';
import phoneModelDialogInfoVue from './phone-model-dialog-info.vue';
import phoneModelSwiperVue from './phone-model-swiper.vue';

export default {
  name: 'PhoneModelDialog',
  mixins: [mixinModel],
  components: {
    phoneModelDialogInfoVue,
    modelPointCloudVue,
    phoneModelSwiperVue
  },
  props: {
    size: {
      type: String,
      default: '100vh'
    },
    relicDetail: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    photos() {
      return this.relicDetail?.realisticPic;
    },
    drawings() {
      return this.relicDetail?.draw;
    },
    relicInfo() {
      return this.relicDetail;
    },
    relicName() {
      return this.relicDetail?.name;
    },
    visibleSize() {
      return this.size == '480px';
    }
  },
  watch: {
    modelValue(newValue) {
      newValue ? this.isActive : (this.isActive = 1);
    }
  },
  data() {
    return {
      isActive: 1,
      direction: 'btt',
      navList: [
        {
          label: '建筑简介',
          visible: true
        },
        {
          label: '三维模型',
          visible: this.relicDetail.pointCloudUrl
        },
        {
          label: '测绘图纸',
          visible: this.relicDetail?.draw
        },
        {
          label: '实景照片',
          visible: this.relicDetail.realisticPic[0]
        }
      ]
    };
  },
  methods: {
    handelClose() {
      this.isActive = 1;
      this.modelValue = false;
    }
  }
};
</script>

<style lang="scss">
.photo-model-dialog {
  width: 100%;
  background-color: #0d1518;
  color: #fff;
  .header {
    height: 10vh;
    background-color: #000;
    padding: 0.8rem;
    &-title {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
    }
    &-list {
      display: flex;
      justify-content: space-between;
      margin-top: 1rem;
    }
  }
  .tab {
    height: 90vh;
    overflow: auto;
  }
  .is-active {
    color: $primary;
  }
}
</style>
